import React, { ReactNode } from 'react';
import { ReadWritePermissions } from '../../../Auth/components/PermissionGate';
import { IntlShape, useIntl } from 'react-intl';
import { ValidationResult } from '../../../util/validation/interfaces';
import { InputNumber, InputNumberChangeEvent } from 'primereact/inputnumber';
import { Labelled, LabelledProps } from './Labelled';

interface LabelledInputTextProps extends LabelledProps {
  id: string;
  value: number;
  permissions: ReadWritePermissions;
  validation: ValidationResult;
  onChange: (value: number) => void;
  pattern?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  min?: number;
  max?: number;
  step?: number;
  maxFractionDigits?: number;
  useGrouping?: boolean;
  allowEmpty?: boolean;
  placeholder?: string;
}

export const LabelledInputNumber = (props: LabelledInputTextProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <InputNumber
        id={props.id}
        value={props.value}
        required={props.permissions?.required || props.required}
        invalid={props.validation && !props.validation?.valid}
        disabled={disabled}
        onChange={(e: InputNumberChangeEvent): void => props.onChange(e.value)}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
        pattern={props.pattern}
        autoFocus={props.autoFocus}
        className={props.className}
        min={props.min}
        max={props.max}
        step={props.step}
        maxFractionDigits={props.maxFractionDigits}
        useGrouping={props.useGrouping}
        allowEmpty={props.allowEmpty}
        placeholder={props.placeholder}
      />
    </Labelled>
  );
};
